// Placeholder route so the Sidebar `/audit` link does not 404 until
// B.1.5 Task 10 ships AuditViewerPage (depends on the Task 8 backend
// slice landing first).

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/audit")({
  component: AuditPlaceholder,
});

function AuditPlaceholder() {
  return (
    <section>
      <h2 style={{ margin: "0 0 16px", fontSize: "1.1rem" }}>Audit log</h2>
      <p style={{ color: "var(--text-dim)", fontSize: "0.9rem" }}>
        Audit viewer ships in B.1.5 Task 10 once the{" "}
        <code>GET /api/v1/audit-log</code> backend endpoint (Task 8)
        is in place. Until then query <code>audit_log</code> directly:
      </p>
      <pre
        style={{
          marginTop: 12,
          padding: 12,
          background: "var(--surface-2)",
          border: "1px solid var(--border)",
          borderRadius: 6,
          fontSize: "0.8rem",
          overflowX: "auto",
        }}
      >
{`psql $ORIXEN_HUB_DB_DSN -c "
  SELECT occurred_at, actor_sub, action, resource_type, resource_slug
  FROM audit_log
  ORDER BY occurred_at DESC LIMIT 50;"`}
      </pre>
    </section>
  );
}
